export const CREATE_NEW_CITE_BTN = 'create-new-cite-btn'
export const ALL_CITATIONS_LINK = 'all-citations-link'
export const CHANGE_STYLE_BTN = 'change-style-button'
export const COPY_ALL_BTN = 'copy-all-btn'
export const EXPORT_ALL_BTN = 'export-btn'
export const EXPORT_BTN_GATED = `${EXPORT_ALL_BTN}-gated`
